import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Text, Title } from '../../../../components';
import { COLORS, device } from '../../../../constants';
import { deviceHeight } from '../../../../constants/mediaQueries';
import { SHADOW } from '../../../../constants/animations';

type IndustriesCardType = {
  icon: React.FC;
  title: string;
  subtitle: string | null;
  isSelected: boolean;
  onClick: () => void;
};

export const IndustryCard = forwardRef<HTMLDivElement, IndustriesCardType>(
  (
    { icon: Icon, title, subtitle, isSelected, onClick }: IndustriesCardType,
    ref
  ) => {
    return (
      <IndustryCardContent ref={ref} onClick={onClick} $isSelected={isSelected}>
        <IconWrapper $isSelected={isSelected}>
          <Icon />
        </IconWrapper>
        <IndustryCardText>
          <Title
            title={title}
            size={24}
            weight={600}
            lineHeight={32.4}
            minHeight={23}
            color={
              isSelected ? COLORS.BLACK_TITLE : COLORS.INDUSTRY_INACTIVE_TEXT
            }
          />
          <Text
            text={subtitle}
            size={18}
            lineHeight={27}
            color={
              isSelected ? COLORS.BLACK_SUBTITLE : COLORS.INDUSTRY_INACTIVE_TEXT
            }
          />
        </IndustryCardText>
      </IndustryCardContent>
    );
  }
);

IndustryCard.displayName = 'IndustryCard';

const IndustryCardContent = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: start;
  gap: 20px;
  flex-shrink: 0;
  height: 210px;
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden;
  background-color: ${({ $isSelected }) =>
    $isSelected ? COLORS.WHITE : COLORS.LIGHT_BG_COLOR};
  transition: all 0.3 ease;
  padding: 40px;
  svg {
    color: ${({ $isSelected }) =>
      $isSelected ? COLORS.MAIN_RED : COLORS.BLACK};
    opacity: ${({ $isSelected }) => ($isSelected ? 1 : 0.8)};
  }
  &:hover {
    box-shadow: ${SHADOW.HOVER.SERVICE_CARD};
  }
  width: 100%;
  @media screen and ${deviceHeight.md} and ${device.xl} {
    height: 150px;
    padding: 10px;
    gap: 15px;
  }
  @media screen and ${device.bsm} {
    height: 200px;
    width: 70%;
    padding: 20px;
  }
  @media screen and ${device.sm} {
    height: 150px;
  }
`;

const IconWrapper = styled.div<{ $isSelected: boolean }>`
  @media screen and ${device.md} {
    align-self: flex-start;
    svg {
      width: 30px;
      height: 30px;
    }
  }
`;

const IndustryCardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  scroll-snap-type: none;
  user-select: none;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    display: none;
  }
  @media screen and ${device.xl} {
    > span {
      font-size: 20px;
      line-height: 1.5;
    }
    > h4 {
      font-size: 16px;
      line-height: 1.5;
    }
    gap: 5px;
  }
  @media screen and ${device.md} {
    > span {
      font-size: 18px;
    }
    > h4 {
      font-size: 13px;
    }
  }
  @media screen and ${device.sm} {
    > span {
      font-size: 15px;
    }
    > h4 {
      font-size: 12px;
    }
  }
`;
